import { render } from "./DriverManagementDashboard.vue?vue&type=template&id=4093e59f"
import script from "./DriverManagementDashboard.vue?vue&type=script&lang=js"
export * from "./DriverManagementDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"DriverManagementDashboard.vue"]])

export default __exports__